import { render, staticRenderFns } from "./ThisFooter.vue?vue&type=template&id=417bed35&scoped=true&"
import script from "./ThisFooter.vue?vue&type=script&lang=js&"
export * from "./ThisFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417bed35",
  null
  
)

export default component.exports